<template>
    <div style="height:100%;">
        <popupFestival></popupFestival>
        <div id="wrap">
            <div class="container">
                <div class="login-left">
                    <!-- <div class="logo"><img src="images/logo.png" width="290px"/></div> -->
                    <div class="login-detail">
                        <form action="" method="post" name='myForm' class="basic-grey"  target="_self" autocomplete="off">  
                            <label>
                                <select name="language" @change="changeLanguage(selectedLang)" v-model="selectedLang">
                                    <option value="1" >{{langSelect[1].caption}}</option>
                                    <option value="2" selected>{{langSelect[2].caption}}中文</option>
                                    <option value="3" >{{langSelect[3].caption}}中文</option>
                                </select>                    
                            </label>                 
                            <label>
                                <span><strong>{{langList.login['LOGIN.LBL_LOGIN']}} :</strong></span>
                                <input type="text" name="fr_username" id="username" size="13" v-model="formData.accname" :maxlength="inputLength.username" placeholder="Username"/>
                            </label>
                      
                            <label>
                                <span><strong>{{langList.login['LOGIN.PASSWORD']}} :</strong></span>
                                <input type="password" id="password" name="fr_password" :maxlength="inputLength.password" v-model="formData.pass" placeholder="Password" />
                            </label>
                      
                        
                            <label style='margin-left:80px;'>
                                <input name="fr_submit" class="button" type="submit" @click.prevent="login" :value="langList.login['LOGIN.BTN_LOGIN']">
                                  <div class="mob-btn" v-if="isMobile()">
                                      <span @click="mobile()"><i class="fa fa-mobile" aria-hidden="true"></i></span>
                                  </div>
                            </label>    
                        </form>
                    </div>
                    <div class="login-right"></div>
                </div>
                <div class="clear"></div>
            </div>
        
            <div class="footer-con">
                <div class="footer1"></div>
                <div class="footer2">
                    <span id="footer">&copy; {{domain_name}}</span></br>
                    <table border="0" style="border:1px;margin:0 auto;" cellpadding="0" cellspacing="0"  v-if="showLogo">
                        <tr>
                          <td id='footer'>
                            <table border="0" style='margin-left:15px;' cellpadding="0" cellspacing="0">		
                              <tr>
                                <td>
                                  Powered by
                                </td>	
                              </tr>
                            </table>
                          </td>
                          <td width="4"></td>
                          <td>
                              <img :src='logoSwitch()' style='border:0px;'/>	
                          </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import popupFestival from '../../components/popup-festival'
import authCommon from '../../mixins/authCommon'
export default {
  mixins: [authCommon],
  components: {
      popupFestival,
    },
  data() {
    return {
      selectedLang: null,
	    langSelect: lang_select,
      cookielang: _cookie,
      companycode: window.compcode,
      currentTemplate: window._currentTemplate,
      customTemplate: window._customTemplate,
      langList: window.langList,
      domain_name: window.domain_name,
      formData: {
          accname: "",
          pass: ""
      },
      error: {
        loginIdReq: false,
        message: ""
      },
      token :window.token,
      showLogo: window.showLogo,
    };
  },
  computed: {
  },
  methods: {
    isMobile(){
        if(window._isMobile == '1')  {
            return true
        }
        return false
    },
    mobile(){
      var redirect = window._baseUrl.replace(window._webTemplate, window._mobileTemplate)+'/login?desktop=0';
      window.location.href = redirect
    },

	  logoSwitch(){
        if(this.cookielang == 'en_US'){
            return 'assets/images/eng_3sing.png'
            //return 'assets/images/3Sing-Logo-en.png'
        }
        return 'assets/images/3sing.png'
        //return 'assets/images/3Sing-Logo-cn.png'
    },
	  changeLanguage: function(value) {
        this.$ajax({
          url: "",
          type: "get",
          data: {
            language: value
          }
        }).then(response => {
          window.location.reload();
        });
    },
	  login() {
      if (this.formData.accname == "") {
        this.error.loginIdReq = true;
        this.error.message = this.lang.emptyLoginId;
        alert(this.error.message)
      } else if (this.formData.pass == "") {
        this.error.loginIdReq = true;
        this.error.message = this.lang.emptyPassword;
        alert(this.error.message)
      } else {
        this.error.loginIdReq = false;
        this.formData.token = token.arr_9+'|'+this.formData.accname
        this.$ajax({
          method: "post",
          url: "",
          data: this.formData
        }).catch(error => {
          this.error.loginIdReq = true;
          this.error.message = error.responseJSON.message;
          alert(this.error.message)
        });
      }
    },

  },
  mounted() {
		this.selectedLang = _.findKey(this.langSelect, {
			language_code: this.cookielang
		});
		$('#username').focus();   
  }
};
</script>
<style lang="scss">
@import "~@/styles/base/global";
@import "~@/styles/auth/wkl";
</style>


// WEBPACK FOOTER //
// resources/mhg/vue/apps/auth/wkl.vue